import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "status"]

  set(event) {
    event.preventDefault()

    const days = Number.parseInt(event.currentTarget.dataset.dateShortcutsDaysValue || "0", 10)
    const months = Number.parseInt(event.currentTarget.dataset.dateShortcutsMonthsValue || "0", 10)
    const date = this.today()

    if (days !== 0) date.setDate(date.getDate() + days)
    if (months !== 0) this.addMonths(date, months)

    this.inputTarget.value = this.toISO(date)
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.updateStatus(date)
  }

  clear(event) {
    event.preventDefault()

    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Sem prazo definido."
    }
  }

  addMonths(date, months) {
    const originalDay = date.getDate()

    date.setDate(1)
    date.setMonth(date.getMonth() + months)
    date.setDate(Math.min(originalDay, this.lastDayOfMonth(date)))
  }

  lastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  }

  today() {
    const now = new Date()
    return new Date(now.getFullYear(), now.getMonth(), now.getDate())
  }

  toISO(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }

  updateStatus(date) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = `Prazo definido para ${new Intl.DateTimeFormat("pt-BR").format(date)}.`
  }
}
